import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_UT_SEGUPHARMA_CONFIG_OV

export default class ConfigService {
  listarColumnasTabla (params) {
    return http.get(`${baseUrl}/ov-cli-config/listar`, {
      params,
      headers: {
        loading: true
      }
    })
  }
}
